module.exports = __webpack_public_path__ + "img/icon_1.aad2d4a5.png";